import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconAnnouncemen20pxBlodS = function IconAnnouncemen20pxBlodS(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/_jsx("path", {
      opacity: ".1",
      d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10z",
      fill: "#FF7028"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.56 12.401h1.069l2.544 1.83a.9.9 0 001.424-.73V6.5a.9.9 0 00-1.424-.731L6.63 7.599H5.56a.36.36 0 00-.359.36v4.082c0 .2.161.36.36.36zm5.643-5.915a.3.3 0 01.326-.272A3.596 3.596 0 0114.8 9.797a3.602 3.602 0 01-3.266 3.587.3.3 0 01-.055-.597 2.996 2.996 0 002.721-2.99 3.002 3.002 0 00-2.725-2.985.3.3 0 01-.272-.326zm.8 2.188a1.198 1.198 0 00-.48-.073.3.3 0 01-.031-.599 1.798 1.798 0 011.745 2.515 1.8 1.8 0 01-1.756 1.08.3.3 0 01.035-.6 1.196 1.196 0 001.27-1.194 1.2 1.2 0 00-.784-1.13z",
      fill: "#FF7028"
    })]
  }));
};
export default IconAnnouncemen20pxBlodS;